<div
  class="lum-c-order-fulfillment"
  [ngClass]="{
    'is-in-modal': isInModal,
    'lum-page lum-page--full-height': !isInModal,
  }"
>
  <div
    class="overlay"
    lumAppLoader
    [loading]="loading"
    [classes]="'loading blur'"
  ></div>

  <ng-container *ngIf="isInModal; else headerWhenIsPage">
    <header class="modal-header align-items-center">
      <h2 class="modal-title">
        <ng-container *ngIf="!loading; else titleWhenLoading">
          Fulfillment Order [{{ fulfillmentOrder.orderKey }}]
        </ng-container>
      </h2>
      <div class="ml-auto">
        <ng-container *ngTemplateOutlet="actionsMenu"></ng-container>
      </div>
      <button class="close ml-0" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </header>
  </ng-container>
  <ng-template #headerWhenIsPage>
    <header class="lum-page-header lum-page-header--sticky lum-page-header--card">
      <h2 class="lum-page-header__heading">
        <a [routerLink]="['/shipping/grid-posted-orders']">Sales Orders</a> /
        <ng-container *ngIf="!loading; else titleWhenLoading">
          <a [routerLink]="['/shipping/posted-orders/', salesOrder.id]">
            {{ salesOrder.orderNumber }} ({{ salesOrder.id }})
          </a>
        </ng-container>
        /
        <ng-container *ngIf="!loading; else titleWhenLoading">
          Fulfillment Order [{{ fulfillmentOrder.orderKey }}]
        </ng-container>
      </h2>
      <div class="lum-page-header__actions">
        <ng-container *ngTemplateOutlet="actionsMenu"></ng-container>
      </div>
    </header>
  </ng-template>

  <div class="lum-page-content lum-order-fulfillment__content">
    <mat-card class="lum-page__card">
      <mat-card-content>
        <div class="row">
          <div class="col-md-3 mb-4">
            <div class="lum-label">Fulfillment Order key</div>
            <div class="text-medium">
              {{ fulfillmentOrder.orderKey }}
            </div>
          </div>
          <div class="col-md-3 mb-4">
            <div class="lum-label">Created At</div>
            <div class="text-medium">
              {{ fulfillmentOrder.createdAt | date: 'mediumDate' }}
            </div>
          </div>
          <div class="col-md-3 mb-4">
            <div class="lum-label">Shipped Date</div>
            <div class="text-medium">
              {{ fulfillmentOrder.shipByDate | date: 'mediumDate' }}
            </div>
          </div>
          <div class="col-md-3 mb-4">
            <div class="lum-label">Fulfillment Order Status</div>
            <div class="text-medium">
              {{ fulfillmentOrder.orderStatus }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 mb-4">
            <div class="lum-label">Warehouse Group</div>
            <div class="text-medium">
              {{ fulfillmentOrder.fulfillmentWarehouseGroup }}
            </div>
          </div>
          <div class="col-md-3 mb-4">
            <div class="lum-label">Fulfillment Destination</div>
            <div class="text-medium">
              {{ fulfillmentOrder.fulfillmentChannel }}
            </div>
          </div>
          <div class="col-md-3 mb-4">
            <div class="lum-label">Destination OMS Store</div>
            <div class="text-medium">
              {{ fulfillmentOrder.fulfillmentChannelStore }}
            </div>
          </div>
          <div class="col-md-3 mb-4">
            <div class="lum-label">Quantity Fulfilled</div>
            <div class="text-medium">
              {{ fulfillmentOrder.qtyShipped }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 mb-4">
            <div class="lum-label">Total Cost</div>
            <div class="text-medium">
              {{ fulfillmentOrder.cost | lumCurrency }}
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="lum-page__card">
      <mat-card-content>
        <mat-tab-group
          [selectedIndex]="currentActiveTab"
          (selectedIndexChange)="currentActiveTab = $event"
        >
          <mat-tab label="Items">
            <lum-order-fulfillment-items-table
              [fulfillmentOrderItems]="fulfillmentOrder.fulfillmentOrderItems"
            ></lum-order-fulfillment-items-table>
          </mat-tab>
        </mat-tab-group>
      </mat-card-content>
    </mat-card>

    <mat-card class="lum-page__card">
      <mat-card-content>
        <div class="row">
          <div class="col-md-12">
            <div class="text-medium">Activity Logs</div>
            <lum-activity-log
              *ngIf="!loading"
              [subjectId]="fulfillmentOrder.id"
              [subjectType]="'fulfillment_order'"
            ></lum-activity-log>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<ng-template #titleWhenLoading>
  <div class="overlay" lumAppLoader [classes]="'loading blur'"></div>
</ng-template>

<ng-template #actionsMenu>
  <button
    type="button"
    class="lum-button lum-button--primary"
    [matMenuTriggerFor]="menu"
  >
    Actions
    <i class="flaticon-more"></i>
  </button>

  <mat-menu class="lum-mat-menu" #menu="matMenu">
    <!-- <button
      mat-menu-item
      type="button"
      (click)="updateFulfillmentOrder()"
    >
      <i class="fas-fa-trash"></i> Update Fulfillment Order
    </button> -->
    <button mat-menu-item type="button" (click)="updateStatusFulfillmentOrder()">
      <i class="fas-fa-trash"></i> Update Status Fulfillment Order
    </button>
    <button mat-menu-item type="button" (click)="deleteFulfillmentOrder()">
      <i class="fas-fa-trash"></i> Delete Fulfillment Order
    </button>
  </mat-menu>
</ng-template>
